import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { CustomersServices } from "../../../customers/services";
import { TPVServices } from "../../../tpv/services";
import { InvoicesServices } from "../../services";
import { ConfigurationServices } from '../../../configuration/services';
import { ProvidersServices } from '../../../providers/services';
import { InvoicesListPage } from '../../invoices-list/invoices-list';
import { CurrencyPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FinishProcessPage } from '../../../finish-process/finish-process';
import { TranslateService } from '@ngx-translate/core';
import { SearchServices } from '../../../services/searchs';
import { CustomersCreateInfoPage } from '../../../customers/customers-create/customers-create-info/customers-create-info';
import moment from 'moment';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
  selector: 'page-invoices-create-select-provider',
  templateUrl: 'invoices-create-select-client.html',
})
export class InvoicesCreateSelectClientPage {
  public form: FormGroup;
  c_uid: any;
  c_name: any;
  c_email: any;
  origin: string = 'tpv';
  ticket: any;
  tickets: any;
  customer: any;
  num: any;
  date = moment(new Date()).format('YYYY-MM-DD');
  due_date: any = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public customersServices: CustomersServices,
    public tpvServices: TPVServices,
    public invoicesServices: InvoicesServices,
    public configurationServices: ConfigurationServices,
    public providersServices: ProvidersServices,
    public cp: CurrencyPipe,
    public http: HttpClient,
    public translate: TranslateService,
    public searchServices: SearchServices,
    public analyticsServices: AnalyticsServices) {

    //Params
    this.origin = this.navParams.get('origin');
    //from ticket
    this.ticket = this.navParams.get('ticket');

    this.tickets = this.navParams.get('tickets');
    this.customer = this.navParams.get('customer');

    //d
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.customersServices.getListCustomers(this.globals.restaurant_uid);
    loadingPopup.dismiss();

    this.form = fb.group({
      customer: [this.navParams.get('customer_static'), Validators.compose([Validators.required])],
    });
  }

  async ionViewWillEnter() {
    this.num = await this.invoicesServices.getInvoiceNumber(this.globals.restaurant_uid);
    if (this.customer) {
      this.searchServices.selectCustomer(this.customer);
    }
  }

  loadingInvoiceCreate = this.loadingCtrl.create({
    spinner: 'crescent',
    content: ''
  });
  submit() {
    if (this.invoicesServices.customer_selected != '') {
      //loading
      this.loadingInvoiceCreate.present();
      //
      this.createInvoice();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-cliente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  async createInvoice() {
    //ticket
    //get customer info selected

    this.c_name = this.invoicesServices.customer_selected.name;
    this.c_uid = this.invoicesServices.customer_selected.UID;
    this.c_email = this.invoicesServices.customer_selected.email;

    //convert table ticket to ticket and state pending
    await this.tpvServices.saveTicketInvoice(false, true, 'not specified', this.c_uid);
    var ticket = this.tpvServices.table_tmp.ticket;
    var _num_ticket = this.tpvServices.ticket_uid;
    var _amount_ticket = this.tpvServices.ticket_amount;
    this.tpvServices.cancelTicket('clean');

    //create invoice
    //var num = await this.invoicesServices.getInvoiceNumber(this.globals.restaurant_uid);
    this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices - Create', this.globals.restaurant.email, 'Create/Update', 'Create invoice', 'Income/Expenses', _num_ticket);
    this.insertInvoice(_num_ticket, true, 'create', ticket, _amount_ticket);
    this.invoicesServices.customer_selected = '';
    this.tpvServices.selected_table_tpv = undefined;
  }

  async createInvoiceFromTicket() {
    //ticket
    //get customer info selected
    this.c_name = this.invoicesServices.customer_selected.name;
    this.c_uid = this.invoicesServices.customer_selected.UID;
    this.c_email = this.invoicesServices.customer_selected.email;

    //get ticket from navparamsget
    var ticket = this.ticket;
    var _num_ticket = this.ticket.UID;
    var _amount_ticket = this.ticket.amount;

    //create invoice
    //var num = await this.invoicesServices.getInvoiceNumber(this.globals.restaurant_uid);
    this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices - Create', this.globals.restaurant.email, 'Create/Update', 'Create invoice', 'Income/Expenses', _num_ticket);
    this.insertInvoice(_num_ticket, true, 'create', ticket, _amount_ticket);
  }

  createInvoiceFromTickets() {
    //get customer info selected
    if (this.invoicesServices.customer_selected != '') {
      this.c_name = this.invoicesServices.customer_selected.name;
      this.c_uid = this.invoicesServices.customer_selected.UID;
      this.c_email = this.invoicesServices.customer_selected.email;

      this.insertInvoiceFromTickets(this.tickets, true, 'create');
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-cliente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }

  }

  async saveTicket() {
    if (this.invoicesServices.customer_selected != '') {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: ''
      });
      loadingPopup.present();

      this.c_name = this.invoicesServices.customer_selected.name;
      this.c_uid = this.invoicesServices.customer_selected.UID;
      this.c_email = this.invoicesServices.customer_selected.email;

      //convert table ticket to ticket and state pending
      await this.tpvServices.saveTicketInvoice(true, false, 'not specified', this.c_uid);
      var _num_ticket = this.tpvServices.ticket_uid;
      this.tpvServices.cancelTicket('clean');

      //if invoice existeix
      var _invoice = await this.invoicesServices.checkCustomerInvoiceExists(this.globals.restaurant_uid, this.c_uid);

      if (_invoice) {
        //update
        this.updateInvoice(_num_ticket);
        this.tpvServices.selected_table_tpv = undefined;
        loadingPopup.dismiss();

      } else {
        //insert
        //get number and create invoice
        //var num = await this.invoicesServices.getInvoiceNumber(this.globals.restaurant_uid);

        this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices - Create', this.globals.restaurant.email, 'Create/Update', 'Save invoice', 'Income/Expenses', _num_ticket);
        this.insertInvoice(_num_ticket, false, 'save', '', '');
        this.invoicesServices.customer_selected = '';
        this.tpvServices.selected_table_tpv = undefined;
        loadingPopup.dismiss();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-cliente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
    /*if (this.form.valid) {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: ''
      });
      loadingPopup.present();

      //get customer info selected
      var _cust = this.form.value.customer.split(',;,');

      this.c_name = _cust[1];
      this.c_uid = _cust[0];
      this.c_email = _cust[2];
      //convert tableticket to ticket and state pending
      await this.tpvServices.saveTicketInvoice(true, false, '');
      var _num_ticket = this.tpvServices.ticket_uid;
      this.tpvServices.cancelTicket();

      //if invoice existeix
      var _invoice = await this.invoicesServices.checkCustomerInvoiceExists(this.globals.restaurant_uid, this.c_uid);

      if (_invoice) {
        //update
        this.updateInvoice(_num_ticket);
        loadingPopup.dismiss();

      } else {
        //insert
        //get number and create invoice
        //var num = await this.invoicesServices.getInvoiceNumber(this.globals.restaurant_uid);

        this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices - Create', this.globals.restaurant.email, 'Create/Update', 'Save invoice', 'Income/Expenses', _num_ticket);
        this.insertInvoice(_num_ticket, false, 'save', '', '');
        loadingPopup.dismiss();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-cliente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }*/

  }

  updateInvoice(num) {

    var _list = this.invoicesServices.invoice.list_tickets;
    _list.push(num);

    this.invoicesServices.afs.collection('invoices').doc(this.invoicesServices.invoice.UID).update({
      'list_tickets': _list,
    }).then(() => {
      this.navCtrl.pop();
      this.navCtrl.pop();
    });
  }


  async insertInvoice(_num_ticket, invoice, type, ticket, _amount_ticket) {
    var tickets = [];
    var payed = false;
    if (type == 'create') {
      //get number and create invoice
      //var num = await this.invoicesServices.getInvoiceNumber(this.globals.restaurant_uid);
      var number_invoice = this.num.number;
      tickets.push(_num_ticket);
      payed = true;
    } else {
      number_invoice = '';
      tickets.push(_num_ticket);
      payed = false;
    }

    if (type == 'create') {
      var subtotal = this.globals.createSubTotal(_amount_ticket, this.globals.user_tax);
      var iva = _amount_ticket - subtotal;

      var tax_name = this.globals.user_tax_name;
      var tax_value = this.globals.user_tax;
    } else {
      _amount_ticket = 0;
      subtotal = 0;
      iva = 0;
      tax_name = 'IVA';
      tax_value = 0;

    }

    /*this.invoicesServices.afs.collection('tickets').doc(ticket.UID).update({
      payment: true,
      payment_type: 'not specified',
    });*/

    this.invoicesServices.afs.collection('invoices').add({
      UID_RESTAURANT: this.globals.restaurant_uid,
      invoice_confirm: invoice,
      invoice_number: number_invoice,
      customer: this.c_name + "-" + this.c_email,
      customer_uid: this.c_uid,
      list_tickets: tickets,
      payed: payed,
      created_at: new Date(),
      total: _amount_ticket,
      subtotal: subtotal,
      iva: iva,
      tax_name: tax_name,
      tax_value: tax_value,

    }).then(doc => {
      if (type == 'create') {
        //update invoice number
        var _number_invoice_tt = number_invoice;
        number_invoice++;
        this.invoicesServices.invoiceUpdateNumber(this.globals.restaurant_uid, number_invoice);
        //
        if (ticket.uid_tickettimeline) {
          //crear ticket timeline
          var ticket_timeline = {
            'uid': this.globals.restaurant_uid,
            'uid_doc': ticket.uid_tickettimeline,
            'uid_table': ticket.table_uid,
            'uid_ticket': ticket.UID,
            'type': 'create invoice',
            'waiter': this.globals.user_name,
            'uid_waiter': this.globals.user_uid,
            'movement': _number_invoice_tt.toString(),
            'app_section': 'APP2',
            'date': new Date()
          }
          this.analyticsServices.ticketTimeline(ticket_timeline);
        }

        //send finish page
        this.navCtrl.push(FinishProcessPage, {
          type: 'invoice',
          uid_element: doc.id,
          ticket: ticket,
          customer_uid: this.c_uid,
          origin: this.origin,
        })
      } else {
        this.navCtrl.pop();
        this.navCtrl.pop();
      }
      if (this.origin === 'tpv') {
        this.loadingInvoiceCreate.dismiss();
      }
    });
  }

  async insertInvoiceFromTickets(tickets, invoice, type) {
    var tickets_uid = [];
    var total = 0;
    var number_invoice = this.num.number;

    tickets.forEach(ticket => {
      tickets_uid.push(ticket.UID);
      total += parseFloat(ticket.amount);
    });

    var subtotal = this.globals.createSubTotal(total, this.globals.user_tax);
    var iva = total - subtotal;
    var tax_name = this.globals.user_tax_name;
    var tax_value = this.globals.user_tax;

    //create invoice
    this.invoicesServices.afs.collection('invoices').add({
      UID_RESTAURANT: this.globals.restaurant_uid,
      invoice_confirm: invoice,
      invoice_number: number_invoice,
      customer: this.c_name + "-" + this.c_email,
      customer_uid: this.c_uid,
      list_tickets: tickets_uid,
      payed: true,
      created_at: new Date(this.date),
      due_date: this.due_date != '' ? new Date(this.due_date) : this.due_date,
      total: total,
      subtotal: subtotal,
      iva: iva,
      tax_name: tax_name,
      tax_value: tax_value,
    }).then(doc => {
      this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices - Create', this.globals.restaurant.email, 'Create/Update', 'Create invoice', 'Income/Expenses', number_invoice);
      //update invoice number
      var _number_invoice_tt = number_invoice;
      number_invoice++;
      this.invoicesServices.invoiceUpdateNumber(this.globals.restaurant_uid, number_invoice);
      //marcar todos los tickets como pagados
      tickets.forEach(ticket => {
        if (ticket.payment == false) {
          this.invoicesServices.afs.collection('tickets').doc(ticket.UID).update({
            payment: true
          });
        }
        if (ticket.uid_tickettimeline) {
          //crear ticket timeline
          var ticket_timeline = {
            'uid': this.globals.restaurant_uid,
            'uid_doc': ticket.uid_tickettimeline,
            'uid_table': ticket.table_uid,
            'uid_ticket': ticket.UID,
            'type': 'create invoice',
            'waiter': this.globals.user_name,
            'uid_waiter': this.globals.user_uid,
            'movement': _number_invoice_tt.toString(),
            'app_section': 'APP2',
            'date': new Date()
          }
          this.analyticsServices.ticketTimeline(ticket_timeline);
        }
      })

      this.globals.side_menu_active = 'sales';
      this.navCtrl.setRoot(InvoicesListPage);
    });
  }

  openCreateCustomer() {
    this.providersServices.quick_create = true;
    this.navCtrl.push(CustomersCreateInfoPage);
  }

  openInvoices() {
    this.navCtrl.push(InvoicesListPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices-create/invoices-create-select-client/invoices-create-select-client.ts